<template>
  <transition name="fade" mode="out-in">
    <div
      class="content"
      :id="story.id"
      :class="{ fullscreen: story.fullscreen, right: story.right, left: story.left, videoContent: story.video, imgContent: story.img}"
    >
      <div class="fullscreen" v-if="story.fullscreen">
        <div class="fullImage" :style="{ backgroundImage: story.beeld }">
          <span></span>
          <div>
            <div class="stempel"></div>
            <p class="vrij">Vrij!</p>
            <div class="quote"><span style="background-color: rgba(240, 238, 234, 0.5);">{{ story.text[0]}}</span></div>
            <div class="quoter"><span style="background-color: rgba(240, 238, 234, 0.5);">{{story.text[1]}}</span></div>
            <div class="maand">{{ story.maand }}</div>
          </div>

          <div class="trigger"
          ><div class="triggerV">&lt;</div><div class="triggerText"> Scroll naar beneden
            </div>
          </div>
        </div>
        <div class="caption">{{story.caption}}</div>
      </div>
       <div v-else-if="story.img" class="img" :style="{ backgroundImage: story.img }"><div class="caption">{{story.caption}}</div></div>
       <div v-else-if="story.video" class="video"><iframe :src="story.video + '?dnt=true'" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe><div class="caption">{{story.caption}}</div></div>
      <div v-else class="text" v-for="txt in story.text" :key="txt">{{ txt }}</div>
    </div>
  </transition>
</template>
<style scoped>
.fullscreen {
  height: 100vh;
  min-height: 100vh !important;
  width: 100vw;
  background: #fff;
}
.quote {
  justify-self: center;
  max-width: 400px;
  font-family: RijksoverheidSansTextItalic, Arial, Helvetica, sans-serif;
  font-size: 30px;
  /* line-height: 31px;*/
  text-align: center;
  font-weight: bold;
  color: #34352d;
  text-shadow: #fff 0px 2px 8px;
  position: relative;
  z-index: 200;
}
.quoter {
  margin-top: 10px;
  font-family: RijksoverheidSansText, Arial, Helvetica, sans-serif;
  font-size: 16px;
  /*line-height: 13px; */
  text-align: right;
  text-shadow: #fff 0px 1px 3px;
  color: #34352d;
  position: relative;
  z-index: 200;
}
.maand {
  font-family: BornReady, Arial, Helvetica, sans-serif;
  font-size: 30px;
  color: #F18E05;
  text-align: right;
  text-shadow: #fff 0px 2px 5px;
}

.stempel {
  justify-self: center;
  text-align: center;
  background-size: cover;
  background-position: center;
  background-image: url("../assets/Stempel-75-jaar-bevrijding-van-Nederland (1).png");
  width: 56px;
  height: 55px;
  position:relative;
  left:150px;
  bottom: -125px;
  z-index: 10;
}

.vrij {
  font-family: BornReady, Arial, Helvetica, sans-serif;
  color: #f18e05;
  font-size: 100px;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  width: 56px;
  margin: 0;
  position: relative;
  top: 40px;
  left: -10px;
  z-index: 0;
}
.fullImage {
  height: 100vh;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: space-between;
  width: 100vw;
  align-items: center;
  flex-direction: column;
}
.trigger {
  padding: 10px;
  font-family: RijksoverheidSansText;
  font-size: 28px;
/* NIMH/Bruin */
  color: #55574A;

    text-shadow:  -1px -1px 3px #F0EEEA,
    1px -1px 3px #F0EEEA,
    -1px 1px 3px #F0EEEA,
     1px 1px 3px #F0EEEA;
  margin-bottom: 90px;
}
.triggerV {
  color: #F18E05;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  transform: rotate(-90deg);
  font-family: BornReady, Arial, Helvetica, sans-serif;
  font-size: 90px;
  -moz-animation: bounce 3s infinite;
	-webkit-animation: bounce 3s infinite;
	animation: bounce 3s infinite;

}
@-moz-keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    -moz-transform: rotate(-90deg) translateX(0);
    transform: rotate(-90deg) translateX(0);
  }
  40% {
    -moz-transform: rotate(-90deg) translateX(30px);
    transform: rotate(-90deg) translateX(30px);
  }
  60% {
    -moz-transform: rotate(-90deg) translateX(15px);
    transform: rotate(-90deg) translateX(15px);
  }
}
@-webkit-keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    -webkit-transform: rotate(-90deg) translateX(0);
    transform: rotate(-90deg) translateX(0);
  }
  40% {
    -webkit-transform: rotate(-90deg) translateX(30px);
    transform: rotate(-90deg) translateX(30px);
  }
  60% {
    -webkit-transform: rotate(-90deg) translateX(15px);
    transform: rotate(-90deg) translateX(15px);
  }
}
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    -moz-transform: rotate(-90deg) translateX(0);
    -ms-transform: rotate(-90deg) translateX(0);
    -webkit-transform: rotate(-90deg) translateX(0);
    transform: rotate(-90deg) translateX(0);
  }
  40% {
    -moz-transform: rotate(-90deg) translateX(30px);
    -ms-transform: rotate(-90deg) translateX(30px);
    -webkit-transform: rotate(-90deg) translateX(30px);
    transform: rotate(-90deg) translateX(30px);
  }
  60% {
    -moz-transform: rotate(-90deg) translateX(15px);
    -ms-transform: rotate(-90deg) translateX(15px);
    -webkit-transform: rotate(-90deg) translateX(15px);
    transform: rotate(-90deg) translateX(15px);
  }
}
.triggerText {
  font-weight: bold;
  margin-top: 40px;
}
.content {
  padding-top: 67vh;
  margin-bottom: 0vh;

}
.imgContent, .videoContent {
  padding-top: 0;
  min-height: 400px;
}
.content.fullscreen {
  padding-top: 0px;
}
.text {
  margin-left: 45px;
  margin-right: 5px;
  padding: 20px;
  font-family: RijksoverheidSansText, Arial, Helvetica, sans-serif;
  font-size: 20px;
  line-height: 21px;
  color: #092646;
  background: rgba(240, 238, 234, 0.8);
  border-left: rgba(85, 87, 74, 0.8) solid 2px;
}
.img {
  width: calc(100vw - 50px);
  margin-left: 40px;
  margin-right: 5px;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.video {
  width: calc(100vw - 50px);
  margin-left: 45px;
  margin-right: 5px;
  padding: 20px;
  height: 100%;
  position: relative;
  background-color: rgba(240, 238, 234, 0.5);
  border-left: rgba(240, 238, 234, 0.5) solid 2px;
}

.caption {
  background: rgba(240, 238, 234, 0.8);
  padding: 10px;
  font-family: RijksoverheidSansText, Arial, Helvetica, sans-serif;
  font-size: 16px;
  line-height: 17px;
  font-weight: bold;
  display: inline-block;
  margin-top: 380px;
  margin-left: 20px;
}

.fullscreen .caption {
  bottom: 0;
  left: 0;
  position: absolute;
}

.video .caption {
  bottom: -20px;
  left: 0px;
  position: absolute;
}

@media (min-width: 768px) {
  .content {
    align-self: center;
    margin-left: 60px;
  }
  .content.fullscreen {
    margin-left: 0px;
  }
  .right {
    min-width: 400px;
    width: 50vw;
    right: 50px;
    align-self: flex-end;
  }
  .left {
    margin-left: 100px;
    min-width: 400px;
    width: 50vw;
    align-self: flex-start;
  }
  .text {
    margin: 0px;
    max-width: 600px;
    border-left: rgba(85, 87, 74, 0.8) solid 20px;
  }
  .img {
    margin: 0px;
    max-width: 600px;
  }
  .video {
    margin: 0;
    max-width: 600px;
    border-left: rgba(240, 238, 234, 0) solid 20px;
  }
  .left .img,
  .right .img {
    min-width: 400px;
    width: 50vw;
  }
  .caption {
    margin-top: 380px;
  }
}
</style>

<script>
/**
  De view voor maand/verhaal met het verhaal van die maand
*/

export default {
  props: ["story"],
  name: "Content"
};
</script>
